export { ReportOrderIssuePage as default } from './report-order-issue';
